<template>
  <div>
    {{ message.content }}
  </div>
</template>
<script>
export default {
  name: 'PlainTextMessage',
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/sections/chat/PlainTextMessage.vue